// 22.01.19
import { reduxForm, FormSection, change } from "redux-form";
import * as React from "react";
import { connect } from "react-redux";
import { Grid, Typography } from "@material-ui/core";
import { UserRoles, CaseType } from "src/constants/api";
import {
  // CheckBoxField,
  DateField,
  dateToTimestamp,
  DisableForRoles,
  FlexGridItem,
  FlexTextField,
  // parseNumber,
  // SelectField,
  timestampToDate,
  TextArea,
  validDate,
  HideForRoles,
  validCorrectionIdentifiedDate,
  validCorrectiveActionIdentifiedDate,
  validCorrectionCompletedDate,
  validCorrectiveActionCompletedDate,
  maxLength50,
  ShowForUsernames,
} from "./form_utility";
import {
  actionSaveAttachmentData,
  actionDownloadAttachment,
  actionDeleteAttachment,
} from "src/actions/detail";
import AttachmentContainer from "src/components/common/attachment-container";
import {
  FORM_TYPE_QMU,
  FORM_TYPE_QMU_OER,
  FORM_ERROR_MESSAGE,
} from "src/constants/data.js";
import FormSelect from "../common/form/controls/select";
import {
  recurrentData,
  oerData,
  complaintValidationData,
  responsibilityData,
  needForCorrectionData,
  needforCorrectiveActionData,
} from "../../constants/dropdown";
import PeoplePickerAutoComplete from "../common/form/controls/people-picker/people-picker";
import { openToaster, closeToaster } from "src/actions/common";
import FormSelectAutoComplete from "../common/form/controls/select-autocomplete";
import { solutionCentreList } from "../../constants/api";
import { required } from "./form_utility";
import { recallData } from "../../constants/dropdown";

class QMUFormComponent extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      isOERVisible: true,
      solutionCentreList: [],
      isValidatedAsComplaintIsNo: false,
      isRecurrentYes: false,
      responsibilityList: [],
    };
    this.handleOERChange = this.handleOERChange.bind(this);
  }

  public componentDidMount() {
    const { dispatch, isNewCase } = this.props;
    const {
      mainForm: { values },
    } = this.props.qmuForm;
    if (values.qmus && values.qmus[0] && !values.qmus[0].oer) {
      this.setState({ isOERVisible: false });
    }

    if (
      values.qmus &&
      values.qmus[0] &&
      values.qmus[0].validatedAsComplaint === 0
    ) {
      this.setState({ isValidatedAsComplaintIsNo: true });
      this.props.touch("qmus[0].caseComments");
    }

    if (values.qmus && values.qmus[0] && values.qmus[0].recurrent === 1) {
      this.setState({ isRecurrentYes: true });
      this.props.touch("qmus[0].caseComments");
    }

    // Fill center list

    let listData: any = [];
    for (let index = 0; index < solutionCentreList.length; index++) {
      if (solutionCentreList[index].newName) {
        continue;
      } else {
        listData.push({
          id: solutionCentreList[index].shortName,
          name: `${solutionCentreList[index].fullName} (${solutionCentreList[index].shortName})`,
        });
      }
    }
    if (
      !isNewCase &&
      values.qmus &&
      values.qmus[0] &&
      values.qmus[0].centreToHandleComplaintList &&
      values.qmus[0].centreToHandleComplaintList.length
    ) {
      // Filter out the data from the  list
      for (
        let index = 0;
        index < values.qmus[0].centreToHandleComplaintList.length;
        index++
      ) {
        const filteredData = solutionCentreList.filter(
          (item: any) =>
            item.shortName ===
            values.qmus[0].centreToHandleComplaintList[index].id
        );
        if (filteredData[0].newName) {
          // Remove the new Data
          listData = listData.filter(
            (item: any) => item.id !== filteredData[0].newName
          );
          // Insert the old Data;
          listData.push({
            id: filteredData[0].shortName,
            name: `${filteredData[0].fullName} (${filteredData[0].shortName})`,
          });
        }
      }
    }
    this.setState({ solutionCentreList: listData });

    // Fill Responsibility data
    const respList = responsibilityData.map((item: any) => {
      return {
        id: item.id,
        name: item.name,
      };
    });
    this.setState({ responsibilityList: respList });

    if (!(values.qmus && values.qmus[0] && values.qmus[0].oer !== null)) {
      dispatch(change("mainForm", "qmus[0].oer", 0));
    }

    if (
      !(
        values.qmus &&
        values.qmus[0] &&
        values.qmus[0].recall !== null &&
        values.qmus[0].recall !== undefined
      )
    ) {
      dispatch(change("mainForm", "qmus[0].recall", 0));
    }

    if (
      !(
        values.qmus &&
        values.qmus[0] &&
        values.qmus[0].needForCorrection !== null
      )
    ) {
      dispatch(change("mainForm", "qmus[0].needForCorrection", 2));
    }

    if (
      !(
        values.qmus &&
        values.qmus[0] &&
        values.qmus[0].needforCorrectiveAction !== null
      )
    ) {
      dispatch(change("mainForm", "qmus[0].needforCorrectiveAction", 2));
    }

    this.props.touch("qmus[0].oer");
    this.props.touch("qmus[0].recall");
    this.props.touch("qmus[0].needForCorrection");
    this.props.touch("qmus[0].correction");
    this.props.touch("qmus[0].caseCommentsCi");

    this.props.touch("qmus[0].needforCorrectiveAction");
    this.props.touch("qmus[0].correctiveAction");
    this.props.touch("qmus[0].caseCommentsCc");
  }

  public componentDidUpdate(prevProps: Readonly<any>): void {
    if (prevProps.qmuForm.mainForm.values?.qmus?.[0]?.solutionOwner !== this.props.qmuForm.mainForm.values?.qmus?.[0]?.solutionOwner) {
      const prevSolutionOwner = prevProps.qmuForm.mainForm.values.qmus[0].solutionOwner;
      const currentSolutionOwner = this.props.qmuForm.mainForm.values.qmus[0].solutionOwner;
      // find out if new element has been added to prev
      const diff = currentSolutionOwner?.filter((item: any) => !prevSolutionOwner?.includes(item));
      if (diff && diff.length > 0) {
        const currentCaSolutionOwner = this.props.qmuForm.mainForm.values.qmus[0].caSolutionOwner ?? [];
        const newCaSolutionOwner = [...currentCaSolutionOwner];
        diff.forEach((item: any) => {
          if (!newCaSolutionOwner.find((el: any) => el.value === item.value)) {
            newCaSolutionOwner.push(item);
          }
        });
        this.props.dispatch(change("mainForm", "qmus[0].caSolutionOwner", newCaSolutionOwner));
        this.props.touch("qmus[0].caSolutionOwner");
      }
    }
  }

  public componentWillUnmount() {
    const { closeToaster } = this.props;
    closeToaster();
  }

  private changeCentreToHandleComplaint = (event: any, values: any) => {
    const { dispatch } = this.props;
    let centers: any[] = [];
    if (values && values.length) {
      const unique = values.map((item: any) => {
        centers.push(item.value);
      });

      let centersStr = centers
        .sort((a: any, b: any) => a.localeCompare(b))
        .join(", ");

      dispatch(
        change("mainForm", "qmus[0].centreToHandleComplaint", centersStr)
      );
    } else {
      dispatch(change("mainForm", "qmus[0].centreToHandleComplaint", ""));
    }
  };

  private handleResponsibilityChange = (event: any, values: any) => {
    const { dispatch } = this.props;
    let resp: any[] = [];
    if (values && values.length) {
      const unique = values.map((item: any) => {
        resp.push(item.value);
      });
      //console.log("values", values);
      let respStr = resp.join(", ");
      //console.log("respStr", respStr);
      dispatch(change("mainForm", "qmus[0].responsibility", respStr));
    } else {
      dispatch(change("mainForm", "qmus[0].responsibility", ""));
    }
  };

  public render() {
    const {
      handleSubmit,
      handleChange,
      saveAttachmentData,
      deleteAttachment,
      downloadAttachment,
      attachmentData,
      uniqueId,
      attachmentDataQmuOer,
      solutionOwner,
      solutionTeam,
      submitFailed,
      invalid,
      openToaster,
      closeToaster,
      isToasterVisible,
    } = this.props;

    const disableForm = this.disableForm();
    if (submitFailed && invalid) {
      openToaster(FORM_ERROR_MESSAGE, false);
    } else if (!invalid && isToasterVisible) {
      closeToaster();
    }

    const needForCorrectionUsernames: string[] = [];
    if (this.props.currentUser.roleId === UserRoles.QMU) {
      needForCorrectionUsernames.push(this.props.currentUser.userName);
    }
    if (this.props.qmuForm.mainForm.values.qmus && this.props.qmuForm.mainForm.values.qmus[0]) {
      // Add solution owner usernames
      if (this.props.qmuForm.mainForm.values.qmus[0].solutionOwner
        && Array.isArray(this.props.qmuForm.mainForm.values.qmus[0].solutionOwner)
        && this.props.qmuForm.mainForm.values.qmus[0].solutionOwner.length > 0) {
        this.props.qmuForm.mainForm.values.qmus[0].solutionOwner.forEach((item: any) => {
          needForCorrectionUsernames.push(item.value);
        });
      }
      // Add solution team usernames
      if (this.props.qmuForm.mainForm.values.qmus[0].solutionTeam
        && Array.isArray(this.props.qmuForm.mainForm.values.qmus[0].solutionTeam)
        && this.props.qmuForm.mainForm.values.qmus[0].solutionTeam.length > 0) {
        this.props.qmuForm.mainForm.values.qmus[0].solutionTeam.forEach((item: any) => {
          if (needForCorrectionUsernames.indexOf(item.value) === -1) {
            needForCorrectionUsernames.push(item.value);
          }
        });
      }
      // Add CA solution owner usernames
      if (this.props.qmuForm.mainForm.values.qmus[0].caSolutionOwner
        && Array.isArray(this.props.qmuForm.mainForm.values.qmus[0].caSolutionOwner)
        && this.props.qmuForm.mainForm.values.qmus[0].caSolutionOwner.length > 0) {
        this.props.qmuForm.mainForm.values.qmus[0].caSolutionOwner.forEach((item: any) => {
          if (needForCorrectionUsernames.indexOf(item.value) === -1) {
            needForCorrectionUsernames.push(item.value);
          }
        })
      }
    }

    return (
      <form
        onSubmit={handleSubmit}
        onChange={handleChange}
      // className={`${disableForm ? "disableForm" : ""}`}
      >
        <FormSection name="qmus[0]">
          <Grid style={{ paddingTop: "25px" }} container={true} spacing={2}>
            <FlexGridItem xs={12}>
              <DisableForRoles
                roles={[
                  UserRoles.Partner,
                  UserRoles.UNICEF,
                  UserRoles.FMC,
                  UserRoles.INS,
                  UserRoles.Solution_Owner,
                  UserRoles.Solution_Team,
                ]}
                disableField={disableForm}
              >
                <FormSelectAutoComplete
                  name="centreToHandleComplaintList"
                  label="Centre to handle complaint"
                  data={this.state.solutionCentreList}
                  isMulti={true}
                  disabled={disableForm}
                  //required={true}
                  // validate={required}
                  onChange={this.changeCentreToHandleComplaint}
                />
              </DisableForRoles>
            </FlexGridItem>
            <FlexGridItem xs={12}>
              <FlexTextField
                name="centreToHandleComplaint"
                label="Centre to handle complaint"
                disabled={true}
                readOnly={true}
              // validate={[maxLength50]}
              />
            </FlexGridItem>
            <FlexGridItem xs={6}>
              <DisableForRoles
                roles={[
                  UserRoles.Partner,
                  UserRoles.UNICEF,
                  UserRoles.FMC,
                  UserRoles.INS,
                  UserRoles.Solution_Owner,
                  UserRoles.Solution_Team,
                ]}
                disableField={disableForm}
              >
                <PeoplePickerAutoComplete
                  name="solutionOwner"
                  label="Correction Solution owner/focal point"
                  isMulti={true}
                  data={solutionOwner}
                />
              </DisableForRoles>
            </FlexGridItem>
            <FlexGridItem xs={6}>
              <DisableForRoles
                roles={[
                  UserRoles.Partner,
                  UserRoles.UNICEF,
                  UserRoles.FMC,
                  UserRoles.INS,
                ]}
                disableField={disableForm}
              >
                <PeoplePickerAutoComplete
                  name="solutionTeam"
                  label="Solution team"
                  isMulti={true}
                  data={solutionTeam}
                />
              </DisableForRoles>
            </FlexGridItem>
            <FlexGridItem xs={6}>
              <DisableForRoles
                roles={[
                  UserRoles.Partner,
                  UserRoles.UNICEF,
                  UserRoles.FMC,
                  UserRoles.INS,
                ]}
                disableField={disableForm}
              >
                <FormSelect
                  label="Validated as a complaint"
                  name="validatedAsComplaint"
                  data={complaintValidationData}
                  onChange={this.handleChangeValidateComplaint}
                />
              </DisableForRoles>
            </FlexGridItem>
            <FlexGridItem xs={6}>
              <DateField
                name="validatedDate"
                label="Validated Date"
                format={timestampToDate}
                normalize={dateToTimestamp}
                validate={validDate}
                //  onChange={this.handleValidateDateChange}
                disabled={disableForm}
              />
            </FlexGridItem>
            <FlexGridItem xs={12}>
              <DisableForRoles
                roles={[
                  UserRoles.Partner,
                  UserRoles.UNICEF,
                  UserRoles.FMC,
                  UserRoles.INS,
                ]}
                disableField={disableForm}
              >
                <FormSelect
                  label="Recurrent"
                  name="recurrent"
                  data={recurrentData}
                  onChange={this.handleRecurrentChange}
                />
                {/* <SelectField
                  label="Recurrent"
                  name="recurrent"
                  parse={parseNumber}
                >
                  <option value=""> </option>
                  <option value={1}>Yes</option>
                  <option value={0}>No</option>
                </SelectField> */}
              </DisableForRoles>
            </FlexGridItem>
            <FlexGridItem xs={12}>
              <HideForRoles
                roles={[UserRoles.Partner, UserRoles.UNICEF, UserRoles.FMC]}
              >
                <DisableForRoles
                  roles={[UserRoles.INS]}
                  disableField={disableForm}
                >
                  {this.state.isValidatedAsComplaintIsNo ||
                    this.state.isRecurrentYes ? (
                    <TextArea
                      name="caseComments"
                      label="Case comments"
                      validate={[required]}
                    />
                  ) : (
                    <TextArea name="caseComments" label="Case comments" />
                  )}
                </DisableForRoles>
              </HideForRoles>
            </FlexGridItem>
            <FlexGridItem xs={12}>
              <DisableForRoles
                roles={[
                  UserRoles.Partner,
                  UserRoles.UNICEF,
                  UserRoles.FMC,
                  UserRoles.INS,
                  UserRoles.Solution_Owner,
                  UserRoles.Solution_Team,
                ]}
                disableField={disableForm}
              >
                <FormSelect
                  label="OER"
                  name="oer"
                  data={oerData}
                  required={true}
                  validate={[required]}
                  onChange={this.handleOERChange}
                  isHideNone={true}
                />
                {/* <SelectField
                  label="OER"
                  name="oer"
                  parse={parseNumber}
                  onChange={this.handleOERChange}
                >
                  <option value={undefined} />z
                  <option value={1}>Yes</option>
                  <option value={0}>No</option>
                </SelectField> */}
              </DisableForRoles>
            </FlexGridItem>
            <FlexGridItem xs={12}>
              <HideForRoles
                roles={[
                  UserRoles.INS,
                  UserRoles.FMC,
                  UserRoles.UNICEF,
                  UserRoles.Partner,
                  UserRoles.Solution_Team,
                ]}
                disableField={disableForm}
              >
                <FormSelect
                  label="Recall"
                  name="recall"
                  data={recallData}
                  isHideNone={true}
                />
              </HideForRoles>
            </FlexGridItem>
            <FlexGridItem xs={6}>
              <DisableForRoles
                roles={[
                  UserRoles.Partner,
                  UserRoles.UNICEF,
                  UserRoles.FMC,
                  UserRoles.INS,
                ]}
                disableField={disableForm}
              >
                <DateField
                  name="correctionIdentified"
                  label="Correction(s) identified"
                  format={timestampToDate}
                  normalize={dateToTimestamp}
                  validate={[validDate, validCorrectionIdentifiedDate]}
                />
              </DisableForRoles>
            </FlexGridItem>
            <FlexGridItem xs={6}>
              {/* <HideForRoles
                roles={[
                  UserRoles.Admin,
                  UserRoles.INS,
                  UserRoles.FMC,
                  UserRoles.UNICEF,
                  UserRoles.Partner,
                  UserRoles.Solution_Team,
                ]}
              >
                <DisableForRoles
                  roles={[
                    UserRoles.Partner,
                    UserRoles.UNICEF,
                    UserRoles.FMC,
                    UserRoles.INS,
                  ]}
                  disableField={disableForm}
                >
                  <FormSelect
                    label="Need for correction"
                    name="needForCorrection"
                    data={needForCorrectionData}
                    isHideNone={true}
                  />
                </DisableForRoles>
              </HideForRoles> */}
              <ShowForUsernames usernames={needForCorrectionUsernames}>
                <DisableForRoles
                  roles={[
                    UserRoles.Partner,
                    UserRoles.UNICEF,
                    UserRoles.FMC,
                    UserRoles.INS,
                  ]}
                  disableField={disableForm}
                >
                  <FormSelect
                    label="Need for correction"
                    name="needForCorrection"
                    data={needForCorrectionData}
                    isHideNone={true}
                  />
                </DisableForRoles>
              </ShowForUsernames>
            </FlexGridItem>
            <FlexGridItem xs={12}>
              <DisableForRoles
                roles={[
                  UserRoles.Partner,
                  UserRoles.UNICEF,
                  UserRoles.FMC,
                  UserRoles.INS,
                ]}
                disableField={disableForm}
              >
                {this.props.qmuForm.mainForm.values.qmus &&
                  this.props.qmuForm.mainForm.values.qmus[0] &&
                  this.props.qmuForm.mainForm.values.qmus[0].needForCorrection ==
                  1 ? (
                  <TextArea
                    name="correction"
                    label="Correction(s)"
                    validate={[required]}
                    required={true}
                  />
                ) : (
                  <TextArea name="correction" label="Correction(s)" />
                )}
              </DisableForRoles>
            </FlexGridItem>
            <FlexGridItem xs={12}>
              <DisableForRoles
                roles={[
                  UserRoles.Partner,
                  UserRoles.UNICEF,
                  UserRoles.FMC,
                  UserRoles.INS,
                ]}
                disableField={disableForm}
              >
                {this.props.qmuForm.mainForm.values.qmus &&
                  this.props.qmuForm.mainForm.values.qmus[0] &&
                  this.props.qmuForm.mainForm.values.qmus[0].needForCorrection ==
                  0 ? (
                  <TextArea
                    name="caseCommentsCi"
                    label="Case comments for Correction(s)"
                    validate={[required]}
                    required={true}
                  />
                ) : (
                  <TextArea
                    name="caseCommentsCi"
                    label="Case comments for Correction(s)"
                  />
                )}
              </DisableForRoles>
            </FlexGridItem>
            <FlexGridItem xs={6}>
              <DisableForRoles
                roles={[
                  UserRoles.Partner,
                  UserRoles.UNICEF,
                  UserRoles.FMC,
                  UserRoles.INS,
                ]}
                disableField={disableForm}
              >
                <DateField
                  name="correctionCompleted"
                  label="Correction(s) completed"
                  format={timestampToDate}
                  normalize={dateToTimestamp}
                  validate={[validDate, validCorrectionCompletedDate]}
                />
              </DisableForRoles>
            </FlexGridItem>
            <FlexGridItem xs={12}>
              <HideForRoles
                roles={[UserRoles.Partner, UserRoles.UNICEF, UserRoles.FMC]}
              >
                <DisableForRoles
                  roles={[UserRoles.INS]}
                  disableField={disableForm}
                >
                  <TextArea
                    name="rootCauseAnalysis"
                    label="Root cause analysis"
                  />
                </DisableForRoles>
              </HideForRoles>
            </FlexGridItem>
            <FlexGridItem xs={6}>
              <DisableForRoles
                roles={[
                  UserRoles.Partner,
                  UserRoles.UNICEF,
                  UserRoles.FMC,
                  UserRoles.INS,
                  UserRoles.Solution_Owner,
                  UserRoles.Solution_Team,
                ]}
                disableField={disableForm}
              >
                <PeoplePickerAutoComplete
                  name="caSolutionOwner"
                  label="Corrective Action Solution owner/focal point"
                  isMulti={true}
                  data={solutionOwner}
                />
              </DisableForRoles>
            </FlexGridItem>
            <FlexGridItem xs={6} />
            <FlexGridItem xs={6}>
              <DisableForRoles
                roles={[
                  UserRoles.Partner,
                  UserRoles.UNICEF,
                  UserRoles.FMC,
                  UserRoles.INS,
                ]}
                disableField={disableForm}
              >
                <DateField
                  name="correctiveActionIdentified"
                  label="Corrective action(s) identified"
                  format={timestampToDate}
                  normalize={dateToTimestamp}
                  validate={[validDate, validCorrectiveActionIdentifiedDate]}
                />
              </DisableForRoles>
            </FlexGridItem>
            <FlexGridItem xs={6}>
              {/* <HideForRoles
                roles={[
                  UserRoles.Admin,
                  UserRoles.INS,
                  UserRoles.FMC,
                  UserRoles.UNICEF,
                  UserRoles.Partner,
                  UserRoles.Solution_Owner,
                  UserRoles.Solution_Team,
                ]}
              >
                <DisableForRoles
                  roles={[
                    UserRoles.Partner,
                    UserRoles.UNICEF,
                    UserRoles.FMC,
                    UserRoles.INS,
                  ]}
                  disableField={disableForm}
                >
                  <FormSelect
                    label="Need for corrective action"
                    name="needforCorrectiveAction"
                    data={needforCorrectiveActionData}
                    isHideNone={true}
                  />
                </DisableForRoles>
              </HideForRoles> */}
              <ShowForUsernames usernames={needForCorrectionUsernames}>
                <DisableForRoles
                  roles={[
                    UserRoles.Partner,
                    UserRoles.UNICEF,
                    UserRoles.FMC,
                    UserRoles.INS,
                  ]}
                  disableField={disableForm}
                >
                  <FormSelect
                    label="Need for corrective action"
                    name="needforCorrectiveAction"
                    data={needforCorrectiveActionData}
                    isHideNone={true}
                  />
                </DisableForRoles>
              </ShowForUsernames>
            </FlexGridItem>
            <FlexGridItem xs={12}>
              <DisableForRoles
                roles={[
                  UserRoles.Partner,
                  UserRoles.UNICEF,
                  UserRoles.FMC,
                  UserRoles.INS,
                ]}
                disableField={disableForm}
              >
                {this.props.qmuForm.mainForm.values.qmus &&
                  this.props.qmuForm.mainForm.values.qmus[0] &&
                  this.props.qmuForm.mainForm.values.qmus[0]
                    .needforCorrectiveAction == 1 ? (
                  <TextArea
                    name="correctiveAction"
                    label="Corrective action(s)"
                    validate={[required]}
                    required={true}
                  />
                ) : (
                  <TextArea
                    name="correctiveAction"
                    label="Corrective action(s)"
                  />
                )}
              </DisableForRoles>
            </FlexGridItem>
            <FlexGridItem xs={12}>
              {/*<DisableForRoles roles={[UserRoles.Partner, UserRoles.UNICEF, UserRoles.FMC, UserRoles.INS]}>
                <DateField name="caseDateCc" label="Case date" format={timestampToDate} normalize={dateToTimestamp} />
              </DisableForRoles>*/}
              <DisableForRoles
                roles={[
                  UserRoles.Partner,
                  UserRoles.UNICEF,
                  UserRoles.FMC,
                  UserRoles.INS,
                ]}
                disableField={disableForm}
              >
                {this.props.qmuForm.mainForm.values.qmus &&
                  this.props.qmuForm.mainForm.values.qmus[0] &&
                  this.props.qmuForm.mainForm.values.qmus[0]
                    .needforCorrectiveAction == 0 ? (
                  <TextArea
                    name="caseCommentsCc"
                    label="Case comments for Corrective action(s)"
                    validate={[required]}
                    required={true}
                  />
                ) : (
                  <TextArea
                    name="caseCommentsCc"
                    label="Case comments for Corrective action(s)"
                  />
                )}
              </DisableForRoles>
            </FlexGridItem>
            <FlexGridItem xs={6}>
              <DisableForRoles
                roles={[
                  UserRoles.Partner,
                  UserRoles.UNICEF,
                  UserRoles.FMC,
                  UserRoles.INS,
                ]}
                disableField={disableForm}
              >
                <DateField
                  name="correctiveActionCompleted"
                  label="Corrective action(s) completed"
                  format={timestampToDate}
                  normalize={dateToTimestamp}
                  validate={[validDate, validCorrectiveActionCompletedDate]}
                />
              </DisableForRoles>
            </FlexGridItem>
            <FlexGridItem xs={6}>
              <HideForRoles
                roles={[
                  UserRoles.Admin,
                  UserRoles.INS,
                  UserRoles.FMC,
                  UserRoles.UNICEF,
                  UserRoles.Partner,
                  UserRoles.Solution_Owner,
                  UserRoles.Solution_Team,
                ]}
              >
                <DisableForRoles
                  roles={[
                    UserRoles.Admin,
                    UserRoles.INS,
                    UserRoles.FMC,
                    UserRoles.UNICEF,
                    UserRoles.Partner,
                    UserRoles.Solution_Owner,
                    UserRoles.Solution_Team,
                  ]}
                  disableField={disableForm}
                >
                  <FormSelectAutoComplete
                    name="responsibilityList"
                    label="Responsibility"
                    data={this.state.responsibilityList}
                    isMulti={true}
                    disabled={disableForm}
                    //required={true}
                    // validate={required}
                    onChange={this.handleResponsibilityChange}
                  />
                </DisableForRoles>
              </HideForRoles>
            </FlexGridItem>
            {/* <FlexGridItem xs={6}>
              <DisableForRoles
                roles={[
                  UserRoles.Partner,
                  UserRoles.UNICEF,
                  UserRoles.FMC,
                  UserRoles.INS
                ]}
              >
                <CheckBoxField
                  name="requestForClosureOfComplaint"
                  label="Request for closure of complaint"
                />
              </DisableForRoles>
            </FlexGridItem> */}
            <DisableForRoles
              roles={[
                UserRoles.Partner,
                UserRoles.UNICEF,
                UserRoles.FMC,
                UserRoles.INS,
              ]}
              disableField={disableForm}
            >
              <AttachmentContainer
                label="Attachments"
                uniqueId={uniqueId}
                onSave={saveAttachmentData}
                attachment={attachmentData}
                download={downloadAttachment}
                remove={deleteAttachment}
                type={FORM_TYPE_QMU}
                {...this.props}
              />
            </DisableForRoles>
          </Grid>
          <hr />
          <Grid style={{ paddingTop: "10px" }} container={true} spacing={2}>
            <FlexGridItem xs={12} />
            {this.state.isOERVisible && (
              <>
                <FlexGridItem xs={12}>
                  <Typography variant="h6" gutterBottom>
                    OER details
                  </Typography>
                </FlexGridItem>
                <FlexGridItem xs={6}>
                  <DisableForRoles
                    roles={[
                      UserRoles.Partner,
                      UserRoles.UNICEF,
                      UserRoles.FMC,
                      UserRoles.INS,
                      UserRoles.Solution_Owner,
                      UserRoles.Solution_Team,
                    ]}
                    disableField={disableForm}
                  >
                    <FlexTextField
                      name="oernumber"
                      label="1. OER number"
                      validate={[maxLength50]}
                    />
                  </DisableForRoles>
                </FlexGridItem>
                <FlexGridItem xs={6}>
                  <DisableForRoles
                    roles={[
                      UserRoles.Partner,
                      UserRoles.UNICEF,
                      UserRoles.FMC,
                      UserRoles.INS,
                      UserRoles.Solution_Owner,
                      UserRoles.Solution_Team,
                    ]}
                    disableField={disableForm}
                  >
                    <FlexTextField
                      name="financialLossToSd"
                      label="1.2 Financial loss to SD"
                      validate={[maxLength50]}
                    />
                  </DisableForRoles>
                </FlexGridItem>
                <DisableForRoles
                  roles={[
                    UserRoles.Partner,
                    UserRoles.UNICEF,
                    UserRoles.FMC,
                    UserRoles.INS,
                    UserRoles.Solution_Owner,
                    UserRoles.Solution_Team,
                  ]}
                  disableField={disableForm}
                >
                  <AttachmentContainer
                    label="Attachments (OER)"
                    uniqueId={uniqueId}
                    onSave={saveAttachmentData}
                    attachment={attachmentDataQmuOer}
                    download={downloadAttachment}
                    remove={deleteAttachment}
                    type={FORM_TYPE_QMU_OER}
                    {...this.props}
                  />
                </DisableForRoles>

                {/* <FlexGridItem xs={6}> */}
                {/* The field OERAttachments is to be set when attachments are added. */}
                {/* <FlexTextField name="OERAttachments" label="OER Attachments" /> */}
                {/* <DisableForRoles
                    roles={[
                      UserRoles.Partner,
                      UserRoles.UNICEF,
                      UserRoles.FMC,
                      UserRoles.INS
                    ]}
                  >
                    <Button variant="contained" color="primary" type="button">
                      Attach files
                    </Button>
                  </DisableForRoles>
                </FlexGridItem> */}
                <FlexGridItem xs={12} />
                <FlexGridItem xs={12}>
                  <p>
                    <b>Status of OER</b>
                  </p>
                </FlexGridItem>
                <FlexGridItem xs={6}>
                  <DisableForRoles
                    roles={[
                      UserRoles.Partner,
                      UserRoles.UNICEF,
                      UserRoles.FMC,
                      UserRoles.INS,
                      UserRoles.Solution_Owner,
                      UserRoles.Solution_Team,
                    ]}
                    disableField={disableForm}
                  >
                    <DateField
                      name="beingDrafted"
                      label="Being drafted"
                      format={timestampToDate}
                      normalize={dateToTimestamp}
                      validate={validDate}
                    />
                  </DisableForRoles>
                </FlexGridItem>
                <FlexGridItem xs={6} />
                <FlexGridItem xs={6}>
                  <DisableForRoles
                    roles={[
                      UserRoles.Partner,
                      UserRoles.UNICEF,
                      UserRoles.FMC,
                      UserRoles.INS,
                      UserRoles.Solution_Owner,
                      UserRoles.Solution_Team,
                    ]}
                    disableField={disableForm}
                  >
                    <DateField
                      name="sentDoforPreapproval"
                      label="Sent DO for pre-approval"
                      format={timestampToDate}
                      normalize={dateToTimestamp}
                      validate={validDate}
                    />
                  </DisableForRoles>
                </FlexGridItem>
                <FlexGridItem xs={6} />
                <FlexGridItem xs={6}>
                  <DisableForRoles
                    roles={[
                      UserRoles.Partner,
                      UserRoles.UNICEF,
                      UserRoles.FMC,
                      UserRoles.INS,
                      UserRoles.Solution_Owner,
                      UserRoles.Solution_Team,
                    ]}
                    disableField={disableForm}
                  >
                    <DateField
                      name="preapprovedByDo"
                      label="Pre-approved by DO"
                      format={timestampToDate}
                      normalize={dateToTimestamp}
                      validate={validDate}
                    />
                  </DisableForRoles>
                </FlexGridItem>
                <FlexGridItem xs={6} />
                {/*<FlexGridItem xs={6}>
                                    <DisableForRoles
                                        roles={[
                                            UserRoles.Partner,
                                            UserRoles.UNICEF,
                                            UserRoles.FMC,
                                            UserRoles.INS,
                                            UserRoles.Solution_Owner,
                                            UserRoles.Solution_Team,
                                        ]}
                                        disableField={disableForm}
                                    >
                                        <DateField
                                            name="circulatedForComments"
                                            label="Circulated for comments"
                                            format={timestampToDate}
                                            normalize={dateToTimestamp}
                                            validate={validDate}
                                        />
                                    </DisableForRoles>
                                </FlexGridItem>
                                <FlexGridItem xs={6} />*/}
                <FlexGridItem xs={6}>
                  <DisableForRoles
                    roles={[
                      UserRoles.Partner,
                      UserRoles.UNICEF,
                      UserRoles.FMC,
                      UserRoles.INS,
                      UserRoles.Solution_Owner,
                      UserRoles.Solution_Team,
                    ]}
                    disableField={disableForm}
                  >
                    <DateField
                      name="circulatedForSignatures"
                      label="Circulated for signatures"
                      format={timestampToDate}
                      normalize={dateToTimestamp}
                      validate={validDate}
                    />
                  </DisableForRoles>
                </FlexGridItem>
                <FlexGridItem xs={6} />
                <FlexGridItem xs={6}>
                  <DisableForRoles
                    roles={[
                      UserRoles.Partner,
                      UserRoles.UNICEF,
                      UserRoles.FMC,
                      UserRoles.INS,
                      UserRoles.Solution_Owner,
                      UserRoles.Solution_Team,
                    ]}
                    disableField={disableForm}
                  >
                    <DateField
                      name="signed"
                      label="Signed"
                      format={timestampToDate}
                      normalize={dateToTimestamp}
                      validate={validDate}
                    />
                  </DisableForRoles>
                </FlexGridItem>
                <FlexGridItem xs={6} />
              </>
            )}
          </Grid>
        </FormSection>
      </form>
    );
  }

  private handleOERChange = (evt: any) => {
    if (evt.target.value) {
      this.setState({ isOERVisible: true });
    } else {
      this.setState({ isOERVisible: false });
    }
  };

  // @ts-ignore
  private checkUserSO = () => {
    const { currentRoleId } = this.props;
    let isCurrentUserSO = false;
    let disableForm = this.disableForm();

    if (disableForm || currentRoleId === UserRoles.QMU) {
      return disableForm;
    } else if (!disableForm) {
      const { currentUser, caseData } = this.props;
      if (
        currentUser &&
        caseData.hasOwnProperty("qmus") &&
        caseData.qmus.length
      ) {
        const filteredUser = caseData.qmus[0].solutionOwner.filter(
          (item: any) => item.value === currentUser.userName
        );
        if (filteredUser.length) {
          isCurrentUserSO = true;
        }
      }
      if (isCurrentUserSO) {
        disableForm = false;
      } else {
        disableForm = true;
      }
    }
    return disableForm;
  };

  private disableForm = () => {
    const {
      caseData,
      currentRoleId,
      allowEdit,
      isNewCase,
      qmuForm,
      isCurrentUserSO,
    } = this.props;
    let disableForm = false;
    const formValues = qmuForm.mainForm.values;
    if (!allowEdit) {
      disableForm = true;
    } else if (isNewCase) {
      if (
        currentRoleId === UserRoles.Solution_Owner ||
        currentRoleId === UserRoles.Solution_Team
      ) {
        disableForm = true;
      }
    } else if (!isNewCase && caseData) {
      if (
        currentRoleId === UserRoles.QMU &&
        formValues.caseType === CaseType.Claim
      ) {
        disableForm = true;
      } else if (
        currentRoleId === UserRoles.INS &&
        (formValues.caseType === CaseType.Complaint ||
          formValues.caseType === CaseType.ComplaintClaim ||
          formValues.caseType === CaseType.Claim)
      ) {
        disableForm = true;
      } else if (
        currentRoleId === UserRoles.Solution_Owner ||
        currentRoleId === UserRoles.Solution_Team
      ) {
        if (isCurrentUserSO) {
          disableForm = false;
        } else {
          disableForm = true;
        }
      }
    }

    return disableForm;
  };

  private handleChangeValidateComplaint = (event: any) => {
    const value = event.target.value;
    if (value === 0) {
      this.setState({ isValidatedAsComplaintIsNo: true });
      this.props.touch("qmus[0].caseComments");
    } else {
      this.setState({ isValidatedAsComplaintIsNo: false });
    }

    /*
        if (
            (currentRoleId === UserRoles.Solution_Owner ||
                currentRoleId === UserRoles.Solution_Team) &&
            value === 2 &&
            qmuFormValues &&
            qmuFormValues.validatedDate
        ) {
            alert(
                "This is an invalid status change. Please contact sd.complaints@unicef.org for support"
            );
            return;
        }

        if (value === 0 && qmuFormValues && qmuFormValues.validatedDate) {
            this.updateDataBasedOnValidationComplaint(
                qmuFormValues.validatedDate,
                false
            );
        } else if (qmuFormValues && qmuFormValues.validatedDate) {
            this.updateDataBasedOnValidationComplaint(null, true);
        }
        */
  };

  private handleRecurrentChange = (event: any) => {
    const value = event.target.value;
    if (value === 1) {
      this.setState({ isRecurrentYes: true });
      this.props.touch("qmus[0].caseComments");
    } else {
      this.setState({ isRecurrentYes: false });
    }
  };

  private handleValidateDateChange = (event: any) => {
    const { qmuForm, currentRoleId } = this.props;
    const qmuFormValues = qmuForm.mainForm.values.qmus
      ? qmuForm.mainForm.values.qmus[0]
      : null;
    const value = event.target.value;

    if (
      (currentRoleId === UserRoles.Solution_Owner ||
        currentRoleId === UserRoles.Solution_Team) &&
      value &&
      qmuFormValues &&
      qmuFormValues.validatedAsComplaint === 2
    ) {
      alert(
        "This is an invalid status change. Please contact sd.complaints@unicef.org for support"
      );
      return;
    }

    // 0 is the value for No
    if (value && qmuFormValues && qmuFormValues.validatedAsComplaint === 0) {
      this.updateDataBasedOnValidationComplaint(value, false);
    }
  };

  private updateDataBasedOnValidationComplaint = (
    value: any,
    complaintStatus: boolean
  ) => {
    const { dispatch, qmuForm, currentRoleId } = this.props;
    const formValues = qmuForm.mainForm.values;

    dispatch(change("mainForm", "qmus[0].correctionIdentified", value));
    dispatch(change("mainForm", "qmus[0].correctionCompleted", value));
    dispatch(change("mainForm", "qmus[0].correctiveActionIdentified", value));
    dispatch(change("mainForm", "qmus[0].correctiveActionCompleted", value));

    if (
      formValues.caseType &&
      formValues.caseType === CaseType.Complaint &&
      currentRoleId !== UserRoles.Solution_Team &&
      currentRoleId !== UserRoles.Solution_Owner
    ) {
      dispatch(change("mainForm", "complaintStatus", complaintStatus));
    }
  };
}

// mainForm is the name of the form object for the Redux form state store.
// enableReinitialize enables changes to initial data to render.
// keepDirtyOnReinitialize enables to keep edited data on reinitialize.
// destroyOnUnmount enables that data is kept when changing tabs.
const QMUForm = reduxForm({
  form: "mainForm",
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  destroyOnUnmount: false,
  // @ts-ignore
})(QMUFormComponent);

const mapStateToProps = (state: any) => {
  return {
    qmuForm: state.form,
    attachmentData: state.detail.attachmentDataQmu,
    attachmentDataQmuOer: state.detail.attachmentDataQmuOer,
    caseData: state.detail.caseData,
    allowEdit: state.detail.allowEdit,
    solutionOwner: state.detail.solutionOwner,
    solutionTeam: state.detail.solutionTeam,
    isLockForEdit: state.detail.isLockForEdit,
    isToasterVisible: state.common.isToasterVisible,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    saveAttachmentData: (
      file: any,
      uploadedBy: any,
      uniqueId: any,
      prevAttachmentData: any,
      type: string
    ) =>
      dispatch(
        actionSaveAttachmentData(
          file,
          uploadedBy,
          uniqueId,
          prevAttachmentData,
          type
        )
      ),
    downloadAttachment: (fileId: any) =>
      dispatch(actionDownloadAttachment(fileId)),
    deleteAttachment: (fileId: any, attachmentData: any, type: string) =>
      dispatch(actionDeleteAttachment(fileId, attachmentData, type)),
    openToaster: (message: string, success: boolean) =>
      dispatch(openToaster(message, success)),
    closeToaster: () => dispatch(closeToaster()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(QMUForm);
